const middleware = {}

middleware['authorize'] = require('../middleware/authorize.ts')
middleware['authorize'] = middleware['authorize'].default || middleware['authorize']

export default middleware
